import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/views/Layout/index.vue";
import Home from "@/views/Home/index.vue";
import About from "@/views/About/index.vue";
import ContactUs from "@/views/ContactUs/index.vue";
import Term from "@/views/Term/index.vue";
import Partners from "@/views/Partners/index.vue";
import Privacy from "@/views/Privacy/index.vue";
import selectedOffers from "@/views/SelectedOffers/index.vue"
Vue.use(VueRouter)
const routes = [
    {
        path:'',
        component:Layout,
        //路由元信息
        meta:{
            isLogin:true
        },
        children:[
            {
                path:'/',
                name:'Home',
                component:Home
            },
            {
                path:'/About',
                name:'About',
                component:About
            },
            {
                path:'/ContactUs',
                name:'ContactUs',
                component:ContactUs
            },
            {
                path:'/Privacy',
                name:'Privacy',
                component:Privacy
            },
            {
                path:'/Partners',
                name:'Partners',
                component:Partners
            },
            {
                path:'/Term',
                name:'Term',
                component:Term
            },
            {
                path: '/selectedoffers',
                name:'SelectedOffers',
                component: selectedOffers
            }
        ]
    }
]
const router = new VueRouter({
    mode:'history',// 后端支持可开
    routes,
    scrollBehavior () {
        // 路由切换时，始终滚动到页面顶部
        return { x: 0, y: 0 }
    }
})

export default router